import React, { FC, useCallback, useEffect, useState } from 'react';
import Form, { FormSchema } from '../../form/Form';
import { Button, Card, Divider, Typography } from 'antd';
import './loginScreen.less';
import { useHistory } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useConnection, useUserInfo } from '../../connection/Application';
import { loginRequest } from '../../authConfig';
const { Title } = Typography;

const schema: FormSchema = [
  {
    id: 'email',
    type: 'string',
    props: { placeholder: 'Email address' },
    options: {
      rules: [
        { required: true, whitespace: true, message: 'Email is required' },
        { type: 'email', message: 'Invalid Email' },
      ],
    },
  },
  {
    id: 'password',
    type: 'password',
    props: { placeholder: 'Password' },
    options: {
      rules: [{ required: true, whitespace: true, message: 'Password is required' }],
    },
  },
];

const LoginScreen: FC = () => {
  const { instance } = useMsal();
  const history = useHistory();
  const connection = useConnection();
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const user = useUserInfo();
  useEffect(() => {
    if (user) {
      history.replace('/webux/my-goals');
    }
  }, [history, user]);
  const onSubmit = useCallback(
    (formData) => {
      setLoading(true);
      connection
        .post('users/login', { email: formData.email, password: formData.password })
        .then((response) => {
          connection.setSession(response);
        })
        .catch((error) => {
          form.setFields([
            { name: 'password', errors: [error.message] },
            { name: 'email', errors: [' '] },
          ]);
        })
        .finally(() => setLoading(false));
    },
    // eslint-disable-next-line
    [],
  );

  const handleMADLogin = useCallback(() => {
    setLoading(true);
    instance
      .loginPopup(loginRequest)
      .then((e) => {
        connection
          .post('users/login-msal', { idToken: e.idToken })
          .then((response) => {
            // The JWT is now an HttpOnly cookie; the body only carries the public user claims.
            connection.setSession(response);
          })
          .catch(async (error) => {
            await instance.logout();
            form.setFields([
              { name: 'password', errors: [error.message] },
              { name: 'email', errors: [' '] },
            ]);
          })
          .finally(() => setLoading(false));
      })
      .catch(async (e: any) => {
        console.log(e);
        setLoading(false);
      });
  }, [connection, form, instance]);

  return (
    <div className="login">
      <Card className="login-card">
        <img src="../../images/logo.png" alt="logo" />
        <Divider orientation="center">
          <Title level={5}>Sign In</Title>
        </Divider>
        {process.env.REACT_APP_MSAL !== 'true' && (
          <Form form={form} onFinish={onSubmit} layout="vertical">
            <Form.Items schema={schema} />
            <Button htmlType="submit" type="primary" block loading={loading}>
              Sign In
            </Button>
          </Form>
        )}
        {process.env.REACT_APP_MSAL === 'true' && (
          <Button
            onClick={handleMADLogin}
            style={{
              marginTop: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            type="default"
            block
            loading={loading}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              style={{ marginRight: '10px' }}>
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            Sign In With Microsoft
          </Button>
        )}
        <Divider orientation="center" />
        {process.env.REACT_APP_MSAL !== 'true' && (
          <Button
            type="link"
            size="large"
            onClick={() => history.replace('/forget-password')}
            block>
            Forgot Password?
          </Button>
        )}
      </Card>
    </div>
  );
};

export default LoginScreen;
